// import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useTasks } from "../Tasks";
import Empty from "./Empty";
import Task from "./Task";

const TodayTaskList = () => {
  const { todaysTasks } = useTasks();
  const titleString = "Today";

  return (
    <section id={titleString}>
      <h2 className="task-list-title">{titleString}</h2>
      {/* <TransitionGroup className="transition-group"> */}
      {todaysTasks.map((task) => (
        // <CSSTransition timeout={500} classNames="fade" key={task.id}>
        <Task
          id={task.id}
          text={task.text}
          complete={task.complete}
          created={task.created}
          pushed={task.pushed}
        />
        // </CSSTransition>
      ))}
      {/* </TransitionGroup> */}
      <Empty today={true}></Empty>
    </section>
  );
};

export default TodayTaskList;
